export default "__VITE_ASSET__6dfafc87__"